import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Modal,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { registerUser } from "../Allapi/Api"; // Import API function
import Swal from "sweetalert2";

const LoginForm = ({ onClose }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [openRegister, setOpenRegister] = useState(false); // Added missing state

  const [formData, setFormData] = useState({
    name: "",
    mobNo: "",
    email: "",
    examName: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form default behavior
    const success = await registerUser(formData);
    if (success) {
      Swal.fire("Success", "User registered successfully", "success");
      setOpenRegister(false); // Close the register modal
      onClose(); // Also close the login modal
    } else {
      Swal.fire("Error", "Registration failed", "error");
    }
  };

  return (
    <Modal open={true} onClose={onClose}>
      <Box
        sx={{
          width: isSmallScreen ? "90%" : "40%",
          maxWidth: "500px",
          padding: 3,
          backgroundColor: "white",
          margin: "auto",
          marginTop: "5%",
          borderRadius: 2,
          textAlign: "center",
          boxShadow: 3,
        }}
      >
        <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
          Register
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Name"
            name="name"
            fullWidth
            margin="normal"
            value={formData.name}
            onChange={handleChange}
          />
          <TextField
            label="Mobile No"
            name="mobNo"
            fullWidth
            margin="normal"
            value={formData.mobNo}
            onChange={handleChange}
          />
          <TextField
            label="Email"
            name="email"
            fullWidth
            margin="normal"
            value={formData.email}
            onChange={handleChange}
          />
          <TextField
            label="Exam Name"
            name="examName"
            fullWidth
            margin="normal"
            value={formData.examName}
            onChange={handleChange}
          />
          <TextField
            label="Password"
            type="password"
            name="password"
            fullWidth
            margin="normal"
            value={formData.password}
            onChange={handleChange}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
          >
            Register
          </Button>
          <Button onClick={onClose} fullWidth sx={{ mt: 1 }}>
            Cancel
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default LoginForm;
